module.exports = __webpack_public_path__ + "static/media/Web_RGB_3n_MTMT_IGN-CNIG.2feb4ad0.png";